import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import './aside.css';

export default function Aside() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  const menuItems = [
    { to: '/',        label: 'Home',     icon: 'fa-home'     },
    { to: '/about',   label: 'About',    icon: 'fa-user'     },
    { to: '/services',label: 'Services', icon: 'fa-list'     },
    { to: '/portfolio',label:'Portfolio',icon: 'fa-briefcase'},
    { to: '/contact', label: 'Contact',  icon: 'fa-comments' },
    // { to: '/dashboard', label: 'Dashboard',  icon: 'fa-user' }
  ];

  return (
    <div className={`aside ${isOpen ? 'open' : ''}`}>
      <div className="logo">
        <a href="/"><span>S Mostafiz</span></a>
      </div>
      <div
        className={`nav-toggler ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(o => !o)}
      >
        <span />
      </div>
      <ul className="nav">
        {menuItems.map(({ to, label, icon }) => (
          <li key={to}>
            <Link
              to={to}
              className={pathname === to ? 'active' : ''}
              onClick={() => setIsOpen(false)}
            >
              <em className={`fa ${icon}`}></em>
              {label}
            </Link>
          </li>
        ))}
      </ul>
      <div className="footer">Made with ❤️ by SupExe</div>
    </div>
  );
}
